<template>
  <div>
    <div class="body">
      <el-button
        class="add-button"
        @click="toAddAddress"
      >
        {{ $t("sampleApply.accountInfo.addAddress") }}
      </el-button>
      <el-empty
        v-if="userAddressList == null || userAddressList.length == 0"
        :description="$t('sampleApply.accountInfo.noAddress')"
      />
      <div>
        <div class="address-list">
          <div
            v-for="(item, index) in userAddressList"
            :key="index"
            class="address-item"
          >
            <i
              class="el-icon-close"
              style="float: right"
              @click="deleteAddress(item.id)"
            />
            <div class="title">
              <span>{{ item.name }}</span>
              <i
                class="el-icon-edit-outline"
                @click="toEditAddress(item.id)"
              />
              <span v-if="item.defaultFlag == 1">{{ $t("sampleApply.accountInfo.defaultAddress") }}</span>
            </div>
            <div class="address-detail">
              <div>
                <span>{{ $t("sampleApply.accountInfo.receiver") }}：{{ item.name }}</span>
                <span>{{ $t("sampleApply.accountInfo.telephone") }}：{{ item.phone }}</span>
              </div>
            </div>
            <div class="address-detail">
              <div>
                <span>{{ $t("sampleApply.accountInfo.area") }}：{{ joinAddress(item) }}</span>
                <span class="special-address">{{ $t("sampleApply.accountInfo.address") }}：{{ item.detailAddress }}</span>
              </div>
            </div>
            <div class="address-detail">
              <div>
                <span v-if="item.mailCode == null || item.mailCode.trim() == 0">{{ $t("sampleApply.accountInfo.postcode") }}：-</span>
                <span v-else>{{ $t("sampleApply.accountInfo.postcode") }}：{{ item.mailCode }}</span>
                <span v-if="item.email == null || item.email.trim() == 0">{{ $t("sampleApply.accountInfo.email") }}：-</span>
                <span v-else>{{ $t("sampleApply.accountInfo.email") }}：{{ item.email }}</span>
                <i
                  v-if="item.defaultFlag != 1"
                  class="el-icon-circle-check"
                  @click="setUserDefaultAddress(item.userId, item.id)"
                > {{ $t("sampleApply.accountInfo.asDefaultAddress") }}</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--新增/编辑地址弹框-->
    <div class="edit_address_dialog">
      <el-dialog
        :title="title"
        width="40%"
        :visible.sync="showAddressDialog"
        :close-on-click-modal="false"
      >
        <el-form
          ref="newAddress"
          :model="addressForm"
          :rules="rules"
        >
          <el-form-item
            :label="$t('sampleApply.accountInfo.receiver')"
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-input
              v-model="addressForm.name"
              maxlength="50"
              :placeholder="$t('sampleApply.accountInfo.textLengthLimit50')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('sampleApply.accountInfo.telephone')"
            :label-width="formLabelWidth"
            prop="phone"
          >
            <el-input
              v-model="addressForm.phone"
              autocomplete="off"
              maxlength="11"
              show-word-limit
              oninput="value=value.replace(/[^\d]/g,'')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('sampleApply.accountInfo.area')"
            :label-width="formLabelWidth"
            prop="area"
          >
            <div class="vselect">
              <v-select
                v-model="addressForm.province"
                :list="addressList"
                show-name="addressName"
                show-value="addressName"
                height="34"
                width="160"
                border
                @onChange="provinceChange"
              />
              <v-select
                v-model="addressForm.city"
                :list="cityList"
                show-name="addressName"
                show-value="addressName"
                height="34"
                width="160"
                border
                @onChange="cityChange"
              />
              <v-select
                v-model="addressForm.country"
                :list="countyList"
                show-name="addressName"
                show-value="addressName"
                height="34"
                width="160"
                border
              />
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('sampleApply.accountInfo.address')"
            :label-width="formLabelWidth"
            prop="detailAddress"
          >
            <el-input
              v-model="addressForm.detailAddress"
              autocomplete="off"
              maxlength="80"
            />
          </el-form-item>
          <el-form-item
            :label="$t('sampleApply.accountInfo.postcode')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="addressForm.mailCode"
              autocomplete="off"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item
            :label="$t('sampleApply.accountInfo.email')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="addressForm.email"
              autocomplete="off"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <div class="check">
              <el-checkbox
                v-model="addressForm.defaultFlag"
                :label="$t('sampleApply.accountInfo.asDefaultAddress')"
                :true-label="1"
                :false-label="0"
                name="isDefault"
              />
            </div>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="cancel()">
            {{ $t("common.cancel") }}
          </el-button>
          <el-button @click="addNewAddress()">
            {{ $t("common.confirm") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import addressTree from "@/utils/address";

  // 验证地址
  const checkArea = (rule, value, callback) => {
    return callback();
  };
  
  export default {
    name: "UserAddressList",
    data() {
      return {
        showAddressDialog: false,
        formLabelWidth: "100px",
        addressList: [], //省份
        cityList: [], //市
        countyList: [], //区
        isDefault: "1",
        title: this.$t("sampleApply.accountInfo.addAddress"),
        isAddNew: true,
        addressForm: {
          id: "",
          userId: localStorage.getItem("userId"),
          name: "",
          phone: "",
          province:"",
          city:"",
          country:"",
          detailAddress: "",
          mailCode: "",
          defaultFlag: 0,
          email: "",
        },
        // 收货地址列表
        userAddressList: [],
        rules: {
          name: [
            {required: true, message: this.$t("sampleApply.accountInfo.receiverTips"), trigger: "blur"},
          ],
          phone: [
            {required: true, message: this.$t("sampleApply.accountInfo.telephoneTips"), trigger: "blur"},
            {min: 11, max: 11, message: this.$t("sampleApply.accountInfo.validPhoneTips"), trigger: "change"}
          ],
          area: [
            {required: true, validator: checkArea, trigger: "blur"},
          ],
          detailAddress: [
            {required: true, message: this.$t("sampleApply.accountInfo.addressTips"), trigger: "blur"},
          ],
        }
      }
    },
    created() {
      this.getUserAddressListById();
      this.getAddress();
    },
    methods: {
      resetAddressForm() {
        this.addressForm = {
          id: "",
          userId: localStorage.getItem("userId"),
          name: "",
          phone: "",
          province:"",
          city:"",
          country:"",
          detailAddress: "",
          mailCode: "",
          defaultFlag: 0,
          email: "",
        }
      },
      // 将当前收货地址设置为默认收货地址
      setUserDefaultAddress(userId, addressId) {
        let url = "/home/user-address/setUserDefaultAddress";
        let params = {
          userId,
          addressId,
        }
        this.$doPost(url, params).then((res) => {
          if (res.code == 200) {
            this.$message.success(this.$t("sampleApply.accountInfo.setDefaultAddressSuccess"));
            this.getUserAddressListById();
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      // 删除地址
      deleteAddress(addressId) {
        this.$confirm(this.$t("sampleApply.accountInfo.deleteAddressTips"), '', {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          let url = "/home/user-address/deleteUserAddress";
          let addressIdList = [];
          addressIdList.push(addressId);
          this.$doPost(url, addressIdList, true).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.$t("sampleApply.accountInfo.addressDeleteSuccess"));
              this.getUserAddressListById();
            }
          }).catch((err) => {
            console.log(err);
          });
        });
      },
      // 获取用户收货地址列表
      getUserAddressListById() {
        let url = "/home/user-address/getUserAddressByUserId";
        let params = {
          userId: localStorage.getItem("userId"),
        }
        this.$doPost(url, params).then((res) => {
          if (res.code == 200) {
            this.userAddressList = res.data;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      // 编辑、新增收货地址弹框关闭
      cancel() {
        this.showAddressDialog = false;
        this.resetAddressForm();
      },
      // 新增/更新收货地址
      addNewAddress() {
        this.$refs["newAddress"].validate((valid) => {
          // 已校验的数据校验通过
          if (valid) {
            // 新增收货地址
            if (this.isAddNew) {
              let url = "/home/user-address/addUserAddress";
              this.addressForm.userId = localStorage.getItem("userId");
              let userAddresses = [];
              userAddresses.push(this.addressForm);
              this.$doPost(url, userAddresses, true).then((res) => {
                if (res.code == 200) {
                  this.showAddressDialog = false;
                  this.$message.success(this.$t("sampleApply.accountInfo.addressAddSuccess"));
                  this.getUserAddressListById();
                  this.resetAddressForm();
                }
              }).catch((err) => {
                console.log(err);
              });
            } else {
              // 修改收货地址
              let url = "/home/user-address/updateUserAddress";
              let userAddresses = [];
              userAddresses.push(this.addressForm);
              this.$doPost(url, userAddresses, true).then((res) => {
                if (res.code == 200) {
                  this.showAddressDialog = false;
                  this.$message.success(this.$t("sampleApply.accountInfo.addressEditSuccess"));
                  this.getUserAddressListById();
                  this.resetAddressForm();
                }
              }).catch((err) => {
                console.log(err);
              });
            }
            this.showAddressDialog = false;
          }
        });
      },
      // 弹出新增收货地址弹框
      toAddAddress() {
        this.provinceChange(0);
        this.cityChange(0);
        this.title = this.$t("sampleApply.accountInfo.addAddress");
        this.isAddNew = true;
        this.showAddressDialog = true;
      },
      // 弹出编辑收货地址弹框
      toEditAddress(addressId) {
        this.title = this.$t("sampleApply.accountInfo.editAddress");
        this.showAddressDialog = true;
        this.isAddNew = false;
        let url = "/home/user-address/getUserAddressById";
        let params = {
          id: addressId,
        }
        this.$doPost(url, params).then((res) => {
          if (res.code == 200) {
            this.addressForm = res.data;
            //判断当前是否又值
            this.addressList.forEach((element) => {
              if (element.addressName == this.addressForm.province) {
                this.cityList = element.addressList;
              }
            });

            this.cityList.forEach((element) => {
              if (element.addressName == this.addressForm.city) {
                this.countyList = element.addressList;
              }
            });
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      // 空格拼接地址信息
      joinAddress(item) {
        return `${item.province} ${item.city} ${item.country}`;
      },
      // 地址选择省份变化
      provinceChange(index) {
        this.cityList = this.addressList[index].addressList;
      },
      // 地址选择市变化
      cityChange(index) {
        this.countyList = this.cityList[index].addressList;
      },
      // 获取国内地址列表
      getAddress() {
        this.addressList = addressTree;
        this.provinceChange(0);
        this.cityChange(0);
      },
    }
  }
</script>

<style scoped lang="less">
  .el-button {
    color: #67C23A;
  }
  
  .body {
    width: 1200px;
    margin: 30px auto 0 auto;
    position: relative;
    
    .add-button {
      position: absolute;
      right: 0;
      top: -50px;
    }
    
    .address-list {
      .address-item {
        border: 1px solid #9BA0A6;
        border-radius: 5px;
        margin-top: 15px;
        padding: 0 18px 18px 18px;
        
        .el-icon-close {
          display: flex;
          justify-content: flex-end;
          margin-top: 5px;
          cursor: pointer;
        }
  
        .el-icon-close:hover {
          font-weight: bold;
          color: #67c23a;
        }
        
        .title {
          line-height: 20px;
          margin-bottom: 10px;
          margin-top: 20px;
          
          span:first-child {
            font-weight: bold;
            margin-right: 8px;
            font-size: 20px;
          }
          
          i {
            font-size: 20px;
            margin-right: 25px;
            cursor: pointer;
          }
          
          i:hover {
            color: #67c23a;
          }
          
          span:last-child {
            color: #67c23a;
            padding: 0 7px;
            font-size: 14px;
            border: 1px solid #67c23a;
            border-radius: 14px;
          }
        }
        
        .address-detail {
          div {
            display: flex;
            justify-content: flex-start;
            margin-top: 6px;
            
            span {
              width: 42%;
              display: inline-block;
            }
            
            i {
              width: 16%;
              text-align: right;
              white-space: nowrap;
            }
            
            i:hover {
              color: #67c23a;
              cursor: pointer;
            }
            
            .special-address {
              width: 50%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            
            .special-address:hover {
              display: flex;
              height: auto;
              overflow: visible;
              text-overflow: initial;
              white-space: pre-wrap;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }
  }

  // 修改地址弹框
  .edit_address_dialog {
    /deep/ .el-dialog__body {
      padding-top: 15px;
      padding-bottom: 0;
    }
    /deep/ .el-dialog__footer {
      text-align: center;
      padding-bottom: 25px;
      padding-top: 0;
      .el-button {
        font-size: 16px;
        margin-right: 20px;
        margin-left: 20px;
        border-radius: 60px;
        padding: 5px 15px;
        /*background-color: #ffffff;*/
        /*color: #67C23A;*/
        border: 1px solid #67C23A;
      }
    }
  }
  .vselect {
    display: flex;
    /*justify-content: space-between;*/
  }
  .vselect > div:not(:last-child) {
    margin-right: 15px;
  }
</style>